import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import {
  Storage,
  getDownloadURL,
  ref,
  uploadBytesResumable,
  percentage,
  fromTask,
} from '@angular/fire/storage';
import { StorageApi, UploadTaskHandle } from '@dges/modules/storage/domain';

@Injectable({
  providedIn: 'root',
})
export class FirebaseStorageService implements StorageApi {
  private storage = inject(Storage);

  startUpload(file: File, folderName: string): UploadTaskHandle {
    const path = `${folderName}/${Date.now()}_${file.name}`;
    const storageRef = ref(this.storage, path);
    const task = uploadBytesResumable(storageRef, file);

    return {
      percentageChanges: () => percentage(task).pipe(map((p) => p.progress)),
      snapshotChanges: () => fromTask(task),
      getDownloadURL: () => getDownloadURL(task.snapshot.ref),
      pause: () => task.pause(),
      resume: () => task.resume(),
      cancel: () => task.cancel(),
    };
  }
}
